import styled from 'styled-components';

export const Title = styled.h1<{ $isMobile: boolean }>`
  ${({ $isMobile }) =>
    $isMobile
      ? `
    min-height: 54px;
    font-size: 18px;
  `
      : `
    min-height: 50px;
    font-size: 28px;
  `};
`;
